import AbstractAPI from '@/services/api/AbstractAPI';

export default class FeedbackAPI extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/feedback');
  }

  async list(options) {
    return this.makeRequest('/inventory', 'get', {params: options});
  }

  async companyStats() {
    return this.makeRequest('/stats', 'get');
  }

  async respond(id, response) {
    return this.makeRequest(`/response/${id}`, 'post', {response});
  }

  async requestFeedback(id) {
    return this.makeRequest(`/request/${id}`, 'get');
  }
}
